<template>
  <transition name="slide-fade">
    <div v-if="notifyFlag" class="bulletin-notify-container">
      <div class="meaasge-content">
        Deleted {{ type }} "<span class="title overflow-management">{{ title }}</span>"
      </div>
      <span class="undo-btn" @click="handleUndo">Undo</span>
      <img src="@/assets/img/share-icon/ic-close-2.svg" alt="" class="close-icon" @click="handleClose" />
    </div>
  </transition>
</template>
<script>
export default {}
</script>
<style lang="scss">
@keyframes notify-show {
  0%{
    right: -500px;
  }
  100%{
    right: 56px;
  }
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.bulletin-notify-wrap {
  z-index: 3000;
  position: fixed;
  bottom: 104px;
  right: 0px;
  .bulletin-notify-container {
    position: relative;
    right: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-radius: 4px;
    background-color: rgba(0, 15, 36, 0.8);
    animation: notify-show cubic-bezier(.18,.89,.32,1.28) .4s;
    &:nth-of-type(1) ~ .bulletin-notify-container {
      margin-top: 16px;
    }
    .meaasge-content {
      font-family: HelveticaNeue, sans-serif;
      font-size: 16px;
      color: #ffffff;
      span {
        display: inline-block;
        vertical-align: top;
        max-width: 190px;
        font-family: HelveticaNeue, sans-serif;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .undo-btn {
      margin-left: 32px;
      font-family: HelveticaNeue-Medium, sans-serif;
      font-size: 16px;
      color: #85b6ff;
      text-decoration: underline;
      cursor: pointer;
    }
    .close-icon {
      margin-left: 24px;
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }
}

</style>
